<template>
    <div id="coupon" data-spider="coupon_list">
        <div v-if="!errorConfig.show && winnerRecord">
            <ul>
                <li data-spider v-for="(item,index) in winnerRecord.data" v-if="item.awardType === 2"
                    @click="use(item.features.coupon.shopId, item.features.coupon.couponId, item.features.coupon.type,$event)">
                    <div class="coupon-left">
                        <p><span>&yen;</span>{{item.features.coupon.reduce | money}}</p>
                        <span>满{{item.features.coupon.full | money}}元可用</span>
                    </div>
                    <div class="coupon-right">
                        <p>中奖时间：{{item.gmtCreated | time}}</p>
                        <span>立即使用</span>
                    </div>
                </li>
            </ul>
            <p class="end" v-if="winnerRecord.data.length > 0">～奖品已经看完了～</p>
            <p class="no-record" v-if="noRecord">～暂无奖品，再接再厉！～</p>
        </div>
        <vm-error :config="errorConfig"></vm-error>
    </div>
</template>

<style lang="less">
    @import '../css/coupon.less';
</style>

<script type="text/ecmascript-6">
    import error from '../../common/vue/error.vue';
    import common from "../../common/js/common";
    import config from '../../../config/api.config';

    export default {
        data() {
            return {
                winnerRecord: null,
                errorConfig: {
                    show: false,
                    status: 1
                },
                noRecord: false
            }
        },
        filters: {
            money(val) {
                return parseFloat(val / 100);
            }
        },
        created() {
            this.getWinnerRecord();
        },
        methods: {
            getWinnerRecord() {
                let self = this;
                common.vap({
                    url: config.getWinerRecord,
                    dataIn: {
                        activityId: app.id,//转盘id
                        code: app.code,
                        activityType: 1
                    },
                    ok: function (result) {
                        self.winnerRecord = self.formatData(result);
                        if (result.data.length === 0) {
                            self.noRecord = true;
                        }
                    },
                    error: function () {
                        self.errorConfig = {show: true, status: 1};
                    }
                });
            },
            formatData(res) {
                res.data.forEach(function (item, index) {
                    item.features !== "" && (item.features = JSON.parse(item.features));
                });
                return res;
            },
            use(shopId, couponId, type, e) {
                //0全店优惠券，1部分商品优惠券
                let originUrl;
                if (type == 0) {
                    originUrl = "https://weidian.com/?userid=" + shopId;
                } else if (type == 1) {
                    originUrl = config.host + '/m/mycoupon/list.html?shop_id=' + shopId + '&coupon_id=' + couponId;
                }
                let newUrl = spider.transferActionBy(originUrl, e.currentTarget);
                location.href = newUrl;
            }
        },
        components: {
            'vm-error': error
        },
        mounted() {
            let self = this;
            if (app.code === undefined || app.id === undefined) {
                self.errorConfig = {show: true, status: 2};
            }
            document.title = '我的奖品';
        }
    }
</script>


/** WEBPACK FOOTER **
 ** coupon.vue?e3bbe76e
 **/